export enum ButtonState {
  Normal = 0,
  Down = 1,
  Hover = 2,
}
